import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
// import IBaseResponse from "../interface/IBaseResponse";
// import { IMoveTrade } from 'src/components/common/MoveTrade/IMoveTrade';

enum RollbackTradeServiceEnum {
  previousPhasesOfTrade = "previous-phases/",
  rollbackTradePhase = "",
  approveWithMessage = "approve-trade-phase-wf?mensagem=",
  rejectWithMessage = "reject?mensagem=",
  phaseReject = "reject",
  phaseReview = "review",
  moveTrade = "move",
  setArchiveTrade = "archive-trade?",
  getContractsModality = "contract/modality/"
}

export default class TradeRollbackPhase extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/rollback-trade-phase/");
  }

  public roolback = async (tradeId: number, phaseTarget: string, reason: string, adminContractModalityId?: number) => {
    const data = this.POST(RollbackTradeServiceEnum.rollbackTradePhase + `?tradeId=${tradeId}&phaseTarget=${phaseTarget}&reason=${reason}&adminContractModalityId=${adminContractModalityId}`, null);

    return data;
  };

  // public previousPhasesOfTrade = async tradeId => this.GET(RollbackTradeServiceEnum.previousPhasesOfTrade + tradeId);

  public previousPhasesOfTrade = async (tradeId: number): Promise<any> => await this.GET(RollbackTradeServiceEnum.previousPhasesOfTrade + tradeId);

  public getContractsModality = async (tradeId: number): Promise<any> => await this.GET(RollbackTradeServiceEnum.getContractsModality + tradeId);
}



// WEBPACK FOOTER //
// ./src/services/api/TradeRollbackPhase.service.ts